import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const MenuBox = styled.ul<{ mode: string }>`
  ${({ theme, mode }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border: 1px solid
      ${mode === 'default' || mode === 'light'
        ? 'transparent'
        : theme.stroke.stroke_1};
    border-radius: 16px;
    background: ${mode === 'default'
      ? theme.backgroundColor.bg_dark_2
      : mode === 'light'
      ? theme.backgroundColor.bg_dark_3
      : theme.backgroundColor.bg_dark_1};
  `}
`;

export const Menu = styled.li`
  ${({ theme }) => css`
    display: block;
    cursor: pointer;

    & > div {
      border-bottom: 1px solid ${theme.stroke.stroke_1};
    }

    &:last-of-type {
      & > div {
        border-bottom: none;
      }
    }
  `}
`;

export const MenuInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  margin: 0 16px;
  padding: 8px 0;
  cursor: pointer;
`;

export const Name = styled.strong<{ red: boolean; mode: string }>`
  ${({ theme, red, mode }) => css`
    ${mode === 'default'
      ? theme.fontStyle.text.body16_medium
      : theme.fontStyle.text.body14_medium}
    color: ${mode === 'transparent'
      ? theme.content.content_light_1
      : red
      ? theme.themeColor.negative
      : theme.content.content_light_1};
  `}
`;

export const RightInfo = styled.strong`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.content_light_1};
  `}
`;
